import Head from 'next/head';
import Link from 'next/link';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { gql } from "@apollo/client";
import client from "../apollo-client";
import Acknowledgment from '../components/Acknowledgment';

export async function getStaticProps() {
    const { data } = await client.query({
      query: gql`{
        volunteerResources {
          edges {
            node {
              attachment {
                attachment {
                  mediaItemUrl
                }
              }
              content
              date
              title
            }
          }
        }
      }
      `,
    });

    return {
      props: {
        volunteerResources: data.volunteerResources.edges,
      },
      revalidate: 10,
   };
}

const Volunteer = ( {volunteerResources} ) => {

    return(
        <div>
            <Head>
                <title>Volunteer - Spark Foundation</title>
                <link rel="icon" href="/favicon-32x32.png" />
                <meta property="og:title" content="Volunteer - Spark Foundation<" key="title" />
                <meta name="description" content="" />
            </Head>

            <div className="relative z-10">
            <Nav/>
                <main className="lg:relative">
                    <div className="relative">
                        <div className="absolute inset-x-0 h-full bg-spark-yellow"></div>
                            <div className="absolute inset-0">
                                <img className="h-full w-full object-cover" src="images/volunteer.jpg" alt="Girl Reading"/>
                                <div className="h-full absolute inset-0 bg-spark-yellow" style={{'mix-blend-mode': 'multiply'}}></div>
                            </div>
                        <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
                       
                            <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-8">
                                <h1 className="text-center text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-7xl mt-16">
                                    <span className="block text-white">VOLUNTEER</span>
                                </h1>

                                <div className="mt-10 max-w-sm mx-auto sm:max-w-none sm:flex sm:justify-center">
                            
                                </div>
                            </div>
                    
                        </div>
                    </div>
                </main>
            </div>
            <Acknowledgment/>

            {/* Current Volunteer Opportunities */}
            <section>
                <div className="relative pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
                    <div className="absolute inset-0">
                        <div className="bg-white h-1/3 sm:h-2/3"></div>
                    </div>
                    <div className="relative max-w-7xl mx-auto">
                        <div className="text-center">
                        <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
                         Opportunities
                        </h2>
                        <p className="mt-3 max-w-7xl mx-auto text-xl text-gray-500 sm:mt-4">
                        If you would like to volunteer with us, please fill in the application linked here and a member of the foundation will reach out to you.                        </p>
                        </div>
                        <div className="mt-8 max-w-lg mx-auto">

                    <div className="mt-2 flex items-center">
                    <a href="https://forms.gle/JTPdmL5uwPmJPThP8" target="_blank" rel="noopener noreferrer" className="inline-flex w-full justify-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-spark-yellow hover:bg-black">
                        Volunteer Application
                    </a>
                  </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* SIGN UP CTA*/}

           {/* <div className="bg-spark-yellow">
                <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
                    <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                    <span className="block">Sign Up For</span>
                    <span className="block">Training Sessions</span>
                    </h2>
                    <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
                    <div className="ml-3 inline-flex rounded-md shadow">
                        <a href="#" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-black hover:bg-gray-700">
                        Sign Up
                        </a>
                    </div>
                    </div>
                </div>
            </div> */}

            {/* Importance of Volunteering */}

            <section>
                <div className="relative bg-gray-100 pt-16 pb-32 overflow-hidden">
                <div className="relative">
                    <div className="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
                    <div className="px-4 max-w-xl mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
                        <div>
                    
                        <div className="mt-6">
                            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900">
                            The Importance of Volunteering
                            </h2>
                            <p className="mt-4 text-lg text-gray-500">
                            Do you want to strengthen your community and help those in need? Do you want to build new skills and meet like-minded people? Volunteering allows you to make a lasting impact in other people’s lives, creating a stronger and healthier community. 
                            </p>
                            <p className="mt-4 text-lg text-gray-500">
                            Volunteering also serves as a gateway for you to learn new skills and enable you to meet new people to connect with. By helping others, you are also helping yourself, so why not volunteer if you have the time to?
                            </p>
                           
                        </div>
                        </div>
                 
                    </div>
                    <div className="mt-12 sm:mt-16 lg:mt-0">
                        <div className="pl-4 -mr-48 sm:pl-6 md:-mr-16 lg:px-0 lg:m-0 lg:relative lg:h-full">
                        <img className="w-full rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 lg:absolute lg:left-0 lg:h-full lg:w-auto lg:max-w-none" src="images/we.jpeg" alt="The SPARK Foundation Team"/>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </section>

             {/* IMPORTANCE OF VOLUNTEER QUOTE */}

                <section className="py-12 bg-white overflow-hidden md:py-20 lg:py-24">
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="relative">
                            <blockquote className="mt-10">
                            <div className="max-w-3xl mx-auto text-center text-3xl leading-9 font-medium text-gray-900">
                                <p>
                                &ldquo;Remember that the happiest people are not those getting more, but those giving more.&rdquo;
                                </p>
                            </div>
                            <footer className="mt-8">
                                <div className="md:flex md:items-center md:justify-center">
                                <div className="mt-3 text-center md:mt-0 md:ml-4 md:flex md:items-center">
                                    <div className="text-lg font-medium text-gray-900">Jackson Brown Jr.</div>
                                </div>
                                </div>
                            </footer>
                            </blockquote>
                        </div>
                    </div>
                </section>

            {/* VOLUNTEER RESOURCES */}
            {/* <section>
                <div className="bg-gray-50 pt-16 pb-20 px-4 sm:px-6 lg:pt-24 lg:pb-28 lg:px-8">
                    <div className="relative max-w-lg mx-auto divide-y-2 divide-gray-200 lg:max-w-7xl">
                    <div>
                        <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
                            Volunteer Resources
                        </h2>
                    
                        <div className="mt-6 pt-10 grid gap-16 lg:grid-cols-2 lg:gap-x-5 lg:gap-y-12">

                        {volunteerResources.length > 0 ? volunteerResources.map((resource, index) => {

                            return(
                                <div key={index} className="bg-white border border-gray-100 px-4 py-4 shadow-md">
                                <p className="text-sm text-gray-500">
                                <time datetime="2020-03-16">{resource.node.date}</time>
                                </p>
                                <a href="#" className="mt-2 block">
                                <p className="text-xl font-semibold text-gray-900">
                                    {resource.node.title}
                                </p>
                                <p className="mt-3 text-base text-gray-500" dangerouslySetInnerHTML={{ __html: resource.node.content }} />
                                </a>
                                <div className="mt-3">
                                <a href={resource.node.attachment.attachment.mediaItemUrl} target="_blank" className="text-base font-semibold text-spark-yellow hover:text-black">
                                    View Resource
                                </a>
                                </div>
                            </div>
                            )

                        }): <p className="text-xl text-spark-yellow">No Volunteer Resources Currently Uploaded</p>}
                            

                        

                        </div>
                    </div>
                </div>
                </div>
            </section>
             */}

        <Footer/>
        </div>
    )
}

export default Volunteer;